var map = {
	"./legal/pages/review": [
		41924,
		[
			2089,
			894,
			9300,
			1922,
			2482,
			5443,
			8547,
			5702,
			3348,
			2954,
			804,
			8549,
			1192,
			1540,
			571,
			8861,
			7000,
			5184,
			4755,
			1829,
			7648,
			1702
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5488;
module.exports = webpackAsyncContext;